import Studio from 'jsreport-studio'
import ShareModal from './ShareModal.js'

Studio.addToolbarComponent((props) => {
  if (!props.tab || !props.tab.entity || props.tab.entity.__entitySet !== 'templates') {
    return <span />
  }

  return <div className='toolbar-button' onClick={() => Studio.openModal(ShareModal, {entity: props.tab.entity})}>
    <i className='fa fa-unlock' />Share
  </div>
})



/** WEBPACK FOOTER **
 ** ./studio/main_dev.js
 **/